// Import react elements
import React, { useState, useEffect } from 'react';

// Import hooks
import useCustomisableTableActions from "global/hooks/useCustomisableTableActions";

// Import components
import CreateButton from 'global/components/CreateButton';
import LoadingScreen from "global/components/loading_ui/LoadingScreen";



const CustomisableTableSelectedRowsActionsDropwdown = ({ tableType, tableData, fetchTableData, handleSelectRow, selectedTableRows, setSelectedRows, isRowDetailsPopUpOpen, onClose, designOrTemplate }) => {

    //console.log(selectedOrderRows);

    // Track the selected action id
    const [selectedActionId, setSelectedActionId] = useState('');



    // Custom hook for actioning order/s
    const {
        tableActionsConfig,
        handleConfirmAndRun,
        isLoading,
        //progress,
        //successfulItems,
        //failedItems,
    } = useCustomisableTableActions({ tableType, tableData, fetchTableData, handleSelectRow, setSelectedRows, onClose, designOrTemplate });



    // Handle selection change
    const handleSelectChangeAction = (e) => {

        // Set selected action to the target value from the dropdown
        setSelectedActionId(e.target.value);

    };



    // Handle submit button click
    const handleActionSubmit = () => {

        // If no action is selected, do nothing
        if (selectedActionId === '') return;

        // Get the selected action by finding the matching id
        const selectedAction = tableActionsConfig.find((action) => action.id === selectedActionId);

        // Execute the action's function
        handleConfirmAndRun(selectedTableRows, selectedAction);

        // Reset the selector
        setSelectedActionId('');

    };



    // useEffect to clear the actions dropdown option to default 'select...' when no rows are selected
    useEffect(() => {

        // Whenever selectedOrderRows changes to an empty array
        if (selectedTableRows?.length === 0) {

            // Clear the selectedActionId
            setSelectedActionId('');

        }

        // Run when dependancies change
    }, [selectedTableRows]);



    return (

        <div>

            <form className="horizontal-align-content-center">

                <select
                    name="Order Action"
                    id="order_action"
                    required
                    value={selectedActionId}
                    onChange={handleSelectChangeAction}
                    className="action-selector__dropdown"
                >

                    <option value="" disabled hidden>Select...</option>


                    {tableActionsConfig

                        // First filter out the invalid actions
                        .filter((action) =>

                            // If more than one row is selected AND this action is single-action-only, hide it
                            !(selectedTableRows?.length > 1 && action.singleItemAction)

                            // And if this is the details pop up and action needs to be hidden
                            && !(isRowDetailsPopUpOpen && action.hideOnOrderDetailsPage) )

                        // Map over the remaining actions
                        .map((action) =>

                            <option key={action.id} value={action.id} style={{ color: action.color }} disabled={action.disabled}>

                                {action.label}

                            </option>

                        )}

                </select>

                <CreateButton title="Go" size="s" onClick={handleActionSubmit} disabled={selectedActionId === ''} />

            </form>

            {/* If the batch processor is running then show loading screen */}
            {isLoading &&
                
                <LoadingScreen loadingMessage="Loading..." />

            }

        </div>

    )

};

export default CustomisableTableSelectedRowsActionsDropwdown;
